<script lang="ts">
    import { MFE_TEAM } from '$lib/services/blocks/constants';
    import type { TMFEName } from '$lib/services/blocks/types';

    export let debug = false;
    export let mfe: TMFEName;
    export let module: string;

    const teamName: string = MFE_TEAM[mfe] || `Missing Team assignment to mfe ${mfe}`;
</script>

{#if debug}
    <div class="group relative">
        <div
            class="pointer-events-none absolute bottom-0 left-0 right-0 top-0 z-[1] box-border hidden group-hover:block group-hover:border-2 group-hover:border-red-30"
        ></div>
        <div
            class="absolute left-0 top-0 z-[1] hidden rounded-br-xl bg-red-30 p-sm text-base text-white group-hover:block"
        >
            <p>Team: {teamName}</p>
            <p>Microfrontend: {mfe}</p>
            <p>Component: {module}</p>
        </div>
        <slot />
    </div>
{:else}
    <slot />
{/if}
